export default __webpack_public_path__ + "static/media/tablets.1764d924.jpg";